import axios from "axios";
import { AddUpdateUserFormInterface, CommonMessageInterface, GetAllUserApiResponse, GetUserByIdApiResponse, GetUserRolesApiResponse } from "../shared/interface/UserManagement/user.interface";
import { RSAEncryption } from "../util/Cryptography";

export const getAllUserList = async (showDeleted?: boolean, customerId?: number | null, locationId?: number | null) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/web-user`;

    if (showDeleted) {
      query += `?showDeleted=${showDeleted}`;
    }

    if (customerId) {
      query += `&customerId=${customerId}`;
    }

    if (locationId) {
      query += `&locationId=${locationId}`;
    }

    const res = await axios.get(query);

    return res.data as GetAllUserApiResponse;
  } catch (error) {
    throw error;
  }
};

export const getUserRoles = async () => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/web-user/user-roles`);

    return res.data as GetUserRolesApiResponse;
  } catch (error) {
    throw error;
  }
};

export const getUserById = async (userId: number, showDeleted?: boolean) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/web-user/${userId}`;

    if (showDeleted) {
      query += `?showDeleted=${showDeleted}`;
    }

    const res = await axios.get(query);

    return res.data as GetUserByIdApiResponse;
  } catch (error) {
    throw error;
  }
};

export const createUser = async (data: AddUpdateUserFormInterface) => {
  const { email_address, mobile_number, ...userData } = data;

  /* add country code with mobile number */
  const formattedMobileNumber = "+91" + mobile_number;

  let userObj: any = {
    ...userData,
    mobile_number: RSAEncryption.encrypt(formattedMobileNumber)
  };

  if (email_address) {
    userObj["email_address"] = RSAEncryption.encrypt(email_address);
  }

  try {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/web-user`, userObj);

    return res.data as CommonMessageInterface;
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (data: AddUpdateUserFormInterface, userId: number) => {
  const { email_address, mobile_number, ...userData } = data;

  let userObj: any = {
    ...userData,
    mobile_number: RSAEncryption.encrypt(mobile_number)
  };

  if (email_address) {
    userObj["email_address"] = RSAEncryption.encrypt(email_address);
  }

  try {
    const res = await axios.put(`${process.env.REACT_APP_API_URL}/web-user/${userId}`, userObj);

    return res.data as CommonMessageInterface;
  } catch (error) {
    throw error;
  }
};

export const deleteUser = async (userId: number) => {
  try {
    const res = await axios.patch(`${process.env.REACT_APP_API_URL}/web-user/change-record-status/${userId}`, {});

    return res.data as CommonMessageInterface;
  } catch (error) {
    throw error;
  }
};
